import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import { IUserProfile, IUserProfileUpdate } from '../interfaces/user-profile.interface';

export interface IPasswordUpdate {
    previousPassword: string;
    newPassword: string;
}

export const UserProfileService = {
    // Get the profile of the currently logged-in user
    getLoggedInUserProfile: async (): Promise<IUserProfile> => {
        try {
            const response = await axios.get(ENDPOINTS.USER_PROFILE.LOGGED_IN_USER_PROFILE, {
                headers: AuthService.getAuthHeader()
            });
            return response.data;
        } catch (error) {
            console.error('Error getting user profile:', error);
            throw error;
        }
    },

    // Get profile by user ID (admin use)
    getProfileByUserId: async (userId: string): Promise<IUserProfile> => {
        try {
            const response = await axios.get(ENDPOINTS.USER_PROFILE.BY_USER(userId), {
                headers: AuthService.getAuthHeader()
            });
            return response.data;
        } catch (error) {
            console.error('Error getting user profile by userId:', error);
            throw error;
        }
    },

    // Update a user's profile
    updateUserProfile: async (profileId: string, profileData: IUserProfileUpdate): Promise<IUserProfile> => {
        try {
            const response = await axios.put(
                ENDPOINTS.USER_PROFILE.UPDATE_PROFILE(profileId),
                profileData,
                { headers: AuthService.getAuthHeader() }
            );
            return response.data;
        } catch (error) {
            console.error('Error updating user profile:', error);
            throw error;
        }
    },

    // Update user password
    updatePassword: async (passwordData: IPasswordUpdate): Promise<void> => {
        try {
            await axios.patch(
                ENDPOINTS.USER.UPDATE_PASSWORD,
                passwordData,
                { headers: AuthService.getAuthHeader() }
            );
        } catch (error) {
            console.error('Error updating password:', error);
            throw error;
        }
    },

    // End every session of the logged-in user (OWASP A07): tokens issued before now are refused
    logoutAllDevices: async (): Promise<void> => {
        try {
            await axios.post(ENDPOINTS.USER.LOGOUT_ALL_DEVICES, null, { headers: AuthService.getAuthHeader() });
        } catch (error) {
            console.error('Error logging out of all devices:', error);
            throw error;
        }
    }
};
